import { MenuItem, FormControl, Select } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { useIntersection } from "utils/CustomHook";
import moment from "moment";

const useStyle = makeStyles((theme) => ({
  iih_selectbox_cls: {
    marginTop: "20px !important",
    width: "100%",
    display: "block",
    "&>div": {
      width: "100%",
      "&>p": {
        margin: 0,
        fontSize: 12,
        lineHeight: "22px",
        display: "flex",
      },
    },
  },
  circularProgress: {
    display: "flex",
    justifyContent: "center",
  },
  menuitem: {
    direction: "rtl",
  },
  menuitemhidden: {
    display: "none",
  },
  iih_selectbox_label:{
    fontSize:"15px !important"
  }
}));

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// common dropdown component
export default function CommonDropDown({
  label = "",
  options = [],
  disabled = false,
  placeholder,
  defaultValue,
  onChangeAction,
  selectedValue = null,
  isloading,
  loadingMore = () => {},
  totalListCount = 0,
  type,
  required = false,
  enableTimeOptions = false,
  ...props
}) {
  const classes = useStyle();
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });

  const [value, setValue] = useState("none");

  const generateTimeOptions = () => {
    const currentTime = moment();

    // test
    // currentTime.setHours(11, 30, 0);

    const startTime = moment().set({ hour: 9, minute: 45, second: 0 });
    const defaultEndTime = moment().set({ hour: 12, minute: 0, second: 0 });
    const endTime = currentTime.isAfter(defaultEndTime) ? currentTime : defaultEndTime;


    const timeOptions = [];

    while (startTime <= endTime) {
      if (startTime <= currentTime) {
        const timeString = startTime.format("HH:mm");
        timeOptions.push({ id: timeString, label: timeString });
      }
      startTime.add(15, "minutes");
    }

    return timeOptions;
  };

  const timeOptions = generateTimeOptions();

  // Push Select time at the start of the array
  timeOptions.unshift({
    id: "none",
    label: "Select Time",
  });

  useEffect(() => {
    if (entry.isIntersecting) {
      if (totalListCount !== options?.length) {
        loadingMore();
      }
    }
  }, [entry]);

  return (
    <div className={classes.iih_selectbox_cls}>
      <FormControl>
        <p className={classes.iih_selectbox_label}>
          {label}{" "}
          {required && (
            <span style={{ color: "red", marginLeft: "5px" }}>*</span>
          )}
        </p>
        <Select
          value={selectedValue || value}
          onChange={onChangeAction}
          disabled={disabled}
          placeholder={placeholder}
          size="small"
          isloading={isloading}
          inputProps={
            {
              // shrink: true,
            }
          }
          MenuProps={MenuProps}
          {...props}
        >
          {isloading && options?.length === 0 && (
            <p className={classes.circularProgress}>Fetching data...</p>
          )}
          {type === "company" ? (
            <div></div>
          ) : placeholder ? (
            <MenuItem key="0" value="none">
              {placeholder}
            </MenuItem>
          ) : null}
          {enableTimeOptions &&
            timeOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}

          {options?.map((option) => (
            <MenuItem key={option?.id} value={option?.id}>
              {option?.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
